import { storyblokEditable } from "gatsby-source-storyblok"
import React from "react"

import Compare from "../../../../V2/Cards/Packages/Compare"

import { storyblokLinkToYocoLink } from "@utils/storyblok"

const StoryblokCompareCard = ({
  blok,
  mobileGridOrder,
}: Storyblok.BlokProps<Storyblok.CompareCard>) => {
  return (
    <Compare
      backgroundColor={blok.backgroundColor}
      accentColor={blok.accentColor}
      heading={blok.title}
      description={blok.description}
      priceValue={blok.priceValue}
      priceSuperscriptText={blok.priceSuperscript}
      priceAdornmentText={blok.priceAdornment}
      priceStrikeSuperscriptText={blok.priceStrikeSuperscript}
      priceSubscriptText={blok.priceSubscript}
      priceDisclaimerText={blok.priceDisclaimer}
      adornmentTextPosition={blok.adornmentTextPosition}
      pillButtonText={blok.primaryCtaText}
      pillButtonUrl={storyblokLinkToYocoLink(blok.primaryCtaLink) ?? ""}
      textButtonText={blok.secondaryCtaText}
      textButtonUrl={storyblokLinkToYocoLink(blok.secondaryCtaLink)}
      badgeText={blok.badge}
      buyerRecievesList={blok.buyerReceivesList}
      mobileGridOrder={mobileGridOrder}
      trackingEvent={blok.trackingEvent}
      trackingEventKey={blok.trackingEventKey}
      trackingEventValue={blok.trackingEventValue}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default StoryblokCompareCard
